import { PerformanceReportEntry } from 'types';
import { PerformanceProductList } from 'pages/performance/components';
import { Modal, Table } from 'components';
import {
  formatMillisecondsToHours,
  formatTimestamp,
  integerToCurrency,
} from 'helpers';
import { PERFORMANCE_ACTION, SALES_MODE, refuseReasons } from 'commons';
import * as S from './styles';

interface PerformanceTableProps {
  performanceData: PerformanceReportEntry[];
}

export function PerformanceTable({ performanceData }: PerformanceTableProps) {
  const reasonsDictionary: { [key: string]: string } = refuseReasons.reduce(
    (accumulator, currentRefuse) => ({
      ...accumulator,
      [currentRefuse.value]: currentRefuse.label,
    }),
    {}
  );

  const renderTableData = performanceData.map((data) => {
    const {
      consignmentCode,
      salesMode,
      createdDate,
      availableDate,
      totalPrice,
      action,
      actionTime,
      actionDate,
      reasonOfRevokeDescription,
    } = data;

    const translatedSalesMode = SALES_MODE[salesMode];
    const {
      formattedDate: formattedCreatedDate,
      hour: hourCreatedDate,
      minute: minuteCreatedDate,
    } = formatTimestamp(createdDate);
    const {
      formattedDate: formattedAvailableDate,
      hour: hourAvailableDate,
      minute: minuteAvailableDate,
    } = formatTimestamp(availableDate);
    const formattedPrice = integerToCurrency(totalPrice.value);
    const formattedAction = PERFORMANCE_ACTION[action];
    const {
      formattedDate: formattedActionDate,
      hour: hourActionDate,
      minute: minuteActionDate,
    } = formatTimestamp(actionDate);
    const {
      hours: hoursAction,
      minutes: minutesAction,
      seconds: secondsAction,
    } = formatMillisecondsToHours(actionTime);
    const reasonOfRefusal = reasonsDictionary[action];

    return (
      <tr key={consignmentCode}>
        <td>{consignmentCode}</td>
        <td>{translatedSalesMode}</td>
        <td>
          {formattedCreatedDate} {hourCreatedDate}:{minuteCreatedDate}
        </td>
        <td>
          {formattedAvailableDate} {hourAvailableDate}:{minuteAvailableDate}
        </td>
        <td>{formattedPrice}</td>
        <td
          className={action === 'CONFIRMED_BY_STORE' ? 'positive' : 'negative'}
        >
          {formattedAction}
        </td>
        <td>
          {formattedActionDate} {hourActionDate}:{minuteActionDate}
        </td>
        <td>
          {hoursAction}:{minutesAction}:{secondsAction}
        </td>
        <td>
          <Modal
            modalContent={
              <PerformanceProductList
                reasonOfRefusal={
                  action === 'CONFIRMED_BY_STORE' ? undefined : reasonOfRefusal
                }
                reasonOfRevokeDescription={reasonOfRevokeDescription}
                consignmentCode={consignmentCode}
              />
            }
          >
            <S.TextLinkStyle>Ver mais</S.TextLinkStyle>
          </Modal>
        </td>
      </tr>
    );
  });

  return (
    <Table
      headers={[
        { name: 'Número do pedido' },
        { name: 'Entrega' },
        { name: 'Criação do pedido' },
        { name: 'Disponibilização do pedido' },
        { name: 'Valor do pedido' },
        { name: 'Ação' },
        { name: 'Dia e hora da ação' },
        { name: 'Tempo de ação' },
        { name: 'Detalhes' },
      ]}
      noResults={!Boolean(performanceData?.length)}
    >
      {renderTableData}
    </Table>
  );
}
